import Vue from 'vue';

import store from '@/store';
import VueRouter from 'vue-router';
import Constants from "@/plugins/constants";
import TheContainer from '@/containers/TheContainer';
import DashboardComponent from '@/components/DashboardComponent';

// native-languages
import NativeLanguagesList from '@/entities/native-languages/NativeLanguagesList';
import NativeLanguageAdd from '@/entities/native-languages/NativeLanguageAdd';
import NativeLanguageEdit from '@/entities/native-languages/NativeLanguageEdit';

// origin-places
import OriginPlacesList from '@/entities/origin-places/OriginPlacesList';
import OriginPlaceAdd from '@/entities/origin-places/OriginPlaceAdd';
import OriginPlaceEdit from '@/entities/origin-places/OriginPlaceEdit';

//users
import UsersList from '@/entities/users/UsersList';
import UserAdd from '@/entities/users/UserAdd';
import UserEdit from '@/entities/users/UserEdit';
import UserAccount from '@/entities/users/UserAccount';
import UserChangeOfPassword from '@/entities/users/UserChangeOfPassword';

// teachers
import TeachersList from '@/entities/teachers/TeachersList';
import TeacherAdd from '@/entities/teachers/TeacherAdd';
import TeacherEdit from '@/entities/teachers/TeacherEdit';
import TeacherScheduleList from '@/entities/teachers/TeacherScheduleList';

// students
import StudentsList from '@/entities/students/StudentsList';
import StudentAdd from '@/entities/students/StudentAdd';
import StudentEdit from '@/entities/students/StudentEdit';
import StudentKardex from "@/entities/students/student-kardex/StudentKardex";
import StudentReportCard from "@/entities/students/student-report-card/StudentReportCard";

// payment-methods
import PaymentMethodsList from '@/entities/payment-methods/PaymentMethodsList';
import PaymentMethodAdd from '@/entities/payment-methods/PaymentMethodAdd';
import PaymentMethodEdit from '@/entities/payment-methods/PaymentMethodEdit';

// items
import ItemsList from '@/entities/items/ItemsList';
import ItemAdd from '@/entities/items/ItemAdd';
import ItemEdit from '@/entities/items/ItemEdit';

// cursos
import CoursesList from '@/entities/courses/CoursesList';
import CourseAdd from '@/entities/courses/CourseAdd';
import CourseEdit from '@/entities/courses/CourseEdit';

// syllabus
import SyllabusList from '@/entities/syllabus/SyllabusList';
import SyllabusAdd from '@/entities/syllabus/SyllabusAdd';
import SyllabusEdit from '@/entities/syllabus/SyllabusEdit';

// syllabus
import SyllabusTuitionsList from '@/entities/syllabus-tuitions/SyllabusTuitionsList';
import SyllabusTuitionAdd from '@/entities/syllabus-tuitions/SyllabusTuitionAdd';
import SyllabusTuitionEdit from '@/entities/syllabus-tuitions/SyllabusTuitionEdit';

// courses-offered
import CoursesOfferedTeacherList from '@/entities/courses-offered/CoursesOfferedTeacherList';
import CoursesOfferedList from '@/entities/courses-offered/CoursesOfferedList';
import CourseOfferedAdd from '@/entities/courses-offered/CourseOfferedAdd';
import CourseOfferedEdit from '@/entities/courses-offered/CourseOfferedEdit';

// courses-syllabus
import CoursesSyllabusList from '@/entities/courses-syllabus/CoursesSyllabusList';
import CourseSyllabusAdd from '@/entities/courses-syllabus/CourseSyllabusAdd';
import CourseSyllabusEdit from '@/entities/courses-syllabus/CourseSyllabusEdit';

// Grades
import GradesImport from '@/entities/grades/GradesImport';
import ReportCard from '@/entities/grades/ReportCard';
import Kardex from '@/entities/grades/Kardex';

// sales
import SalesList from '@/entities/sales/SalesList';
import SaleEdit from '@/entities/sales/SaleEdit';
import SaleView from '@/entities/sales/SaleView';

import RegistrationsStudentList from '@/entities/registrations/RegistrationsStudentList';
import RegistrationsWithTuitionsList from '@/entities/registrations/RegistrationsWithTuitionsList';

// reportes
import ScheduleList from '@/components/reports/ScheduleList';
import RegistrationsDebtList from '@/components/reports/RegistrationsDebtList';
import IncomeList from '@/components/reports/IncomeList';
import StatisticsByPeriodsList from '@/components/reports/StatisticsByPeriodsList';
import StatisticsGeneralByPeriodsList from '@/components/reports/StatisticsGeneralByPeriodsList';
import RegistrationStudents from '@/components/reports/RegistrationStudents';

//configs
// pages
import Page_401 from "@/components/pages/Page_401";
import Page_404 from "@/components/pages/Page_404";
import Page_500 from "@/components/pages/Page_500";

import Login from "@/components/Login";
import RecoverPassword from "@/components/RecoverPassword";
import ChangePassword from "@/components/ChangePassword";

const roles = Constants.roles;

const guard = function async(to, from, next, rolesRoute) {

    let user = store.state.userAuth;
    if (user) {
        let rolesUser = user.roles;
        let hasRole = false;
        if (rolesUser.length > 0) {
            rolesUser.forEach((role) => {
                if (rolesRoute.includes(role.name))
                    hasRole = true;
            });
        }
        if (hasRole) {
            next();
        } else {
            next({
                name: 'Page_401'
            })
        }

    } else {
        next({
            name: 'ingresar'
        })
    }
};

Vue.use(VueRouter)

const routes = [
    {
        path: '/ingresar',
        name: 'ingresar',
        component: Login,
    },
    {
        path: '/recuperar-contrasena',
        name: 'recoverPassword',
        component: RecoverPassword,
    },
    {
        path: '/usuario-cambiar-contrasena/:hash',
        name: 'changePassword',
        component: ChangePassword,
    },
    {
        path: '*',
        name: 'Page_404',
        meta: {
            label: 'Página no encontrada'
        },
        component: Page_404,
    },
    {

        path: '/',
        redirect: '/dashboard',
        component: TheContainer,
        children: [
            {
                path: 'dashboard',
                name: 'dashboad',
                meta: {
                    label: 'Inicio',
                },
                component: DashboardComponent,
                beforeEnter: (to, from, next) => {
                    guard(to, from, next, [
                        roles.ROLE_ADMINISTRATOR,
                        roles.ROLE_SYSTEM,
                        roles.ROLE_TEACHER,
                        roles.ROLE_STUDENT,
                        roles.ROLE_SECRETARY,
                    ]);
                }
            },
            {
                path: 'idiomas-nativos',
                meta: {
                    label: 'Idiomas nativos',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'NativeLanguagesList',
                        meta: {
                            label: 'Lista de idiomas nativos',
                        },
                        component: NativeLanguagesList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'NativeLanguageAdd',
                        meta: {
                            label: 'Añadir idioma nativo'
                        },
                        component: NativeLanguageAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'NativeLanguageEdit',
                        meta: {
                            label: 'Editar idioma nativo'
                        },
                        component: NativeLanguageEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                ]
            },
            {
                path: 'lugares-de-origen',
                meta: {
                    label: 'Lugares de origen',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'OriginPlacesList',
                        meta: {
                            label: 'Lista de lugares de origen',
                        },
                        component: OriginPlacesList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'OriginPlaceAdd',
                        meta: {
                            label: 'Añadir lugar de origen'
                        },
                        component: OriginPlaceAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'OriginPlaceEdit',
                        meta: {
                            label: 'Editar lugar de origen'
                        },
                        component: OriginPlaceEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                ]
            },
            //users
            {
                path: 'usuarios',
                meta: {
                    label: 'Usuarios',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },

                children: [
                    {
                        path: '',
                        name: 'UsersList',
                        meta: {
                            label: 'Lista de usuarios',
                        },
                        component: UsersList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_SYSTEM]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'UserAdd',
                        meta: {
                            label: 'Añadir usuario'
                        },
                        component: UserAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_SYSTEM]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'UserEdit',
                        meta: {
                            label: 'Editar usuario'
                        },
                        component: UserEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_SYSTEM]);
                        },
                    },
                    {
                        path: 'account',
                        name: 'UserAccount',
                        meta: {
                            label: 'Configuración de cuenta'
                        },
                        component: UserAccount
                    },
                    {
                        path: 'password',
                        name: 'UserChangeOfPassword',
                        meta: {
                            label: 'Cambia tu contraseña'
                        },
                        component: UserChangeOfPassword
                    }

                ]
            },
            //teachers
            {
                path: 'profesores',
                meta: {
                    label: 'Profesores',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },

                children: [
                    {
                        path: '',
                        name: 'TeachersList',
                        meta: {
                            label: 'Lista de profesores',
                        },
                        component: TeachersList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'TeacherAdd',
                        meta: {
                            label: 'Añadir profesor'
                        },
                        component: TeacherAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'TeacherEdit',
                        meta: {
                            label: 'Editar profesor'
                        },
                        component: TeacherEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                ]
            },
            //students
            {
                path: 'estudiantes',
                meta: {
                    label: 'Estudiantes',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },

                children: [
                    {
                        path: '',
                        name: 'StudentsList',
                        meta: {
                            label: 'Lista de estudiantes',
                        },
                        component: StudentsList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY, roles.ROLE_SYSTEM]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'StudentAdd',
                        meta: {
                            label: 'Añadir estudiante'
                        },
                        component: StudentAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'StudentEdit',
                        meta: {
                            label: 'Editar estudiante'
                        },
                        component: StudentEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'kardex/:person_id',
                        name: 'StudentKardex',
                        meta: {
                            label: 'Kardex'
                        },
                        component: StudentKardex,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'libreta/:person_id',
                        name: 'StudentReportCard',
                        meta: {
                            label: 'Libreta'
                        },
                        component: StudentReportCard,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                ]
            },
            //items
            {
                path: 'items',
                meta: {
                    label: 'Items',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'ItemsList',
                        meta: {
                            label: 'Lista de items',
                        },
                        component: ItemsList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'ItemAdd',
                        meta: {
                            label: 'Añadir item'
                        },
                        component: ItemAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'ItemEdit',
                        meta: {
                            label: 'Editar item'
                        },
                        component: ItemEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                ]
            },
            //metodos-de-pago
            {
                path: 'metodos-de-pago',
                meta: {
                    label: 'Métodos de pago',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },

                children: [
                    {
                        path: '',
                        name: 'PaymentMethodsList',
                        meta: {
                            label: 'Lista de métodos de pago',
                        },
                        component: PaymentMethodsList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'PaymentMethodAdd',
                        meta: {
                            label: 'Añadir método de pago'
                        },
                        component: PaymentMethodAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'PaymentMethodEdit',
                        meta: {
                            label: 'Editar método de pago'
                        },
                        component: PaymentMethodEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                ]
            },
            //syllabus
            {
                path: 'pensums',
                meta: {
                    label: 'Syllabuss',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'SyllabusList',
                        meta: {
                            label: 'Lista de pensums',
                        },
                        component: SyllabusList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'SyllabusAdd',
                        meta: {
                            label: 'Añadir pensum'
                        },
                        component: SyllabusAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'SyllabusEdit',
                        meta: {
                            label: 'Editar pensum'
                        },
                        component: SyllabusEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                ]
            },
            //cursos
            {
                path: 'cursos',
                meta: {
                    label: 'Cursos',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'CoursesList',
                        meta: {
                            label: 'Lista de cursos',
                        },
                        component: CoursesList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'CourseAdd',
                        meta: {
                            label: 'Añadir curso'
                        },
                        component: CourseAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'CourseEdit',
                        meta: {
                            label: 'Editar curso'
                        },
                        component: CourseEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                ]
            },
            //programas-de-cursos
            {
                path: 'programas-de-cursos',
                meta: {
                    label: 'Programas de cursos',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'CoursesSyllabusList',
                        meta: {
                            label: 'Lista de programas de cursos',
                        },
                        component: CoursesSyllabusList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'CourseSyllabusAdd',
                        meta: {
                            label: 'Añadir programa de curso'
                        },
                        component: CourseSyllabusAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'CourseSyllabusEdit',
                        meta: {
                            label: 'Editar programa de curso'
                        },
                        component: CourseSyllabusEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                ]
            },
            //cursos-ofertados
            {
                path: 'cursos-ofertados',
                meta: {
                    label: 'Cursos ofertados',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'CoursesOfferedList',
                        meta: {
                            label: 'Lista de cursos ofertados',
                        },
                        component: CoursesOfferedList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'CourseOfferedAdd',
                        meta: {
                            label: 'Añadir curso ofertado'
                        },
                        component: CourseOfferedAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'CourseOfferedEdit',
                        meta: {
                            label: 'Editar curso ofertado'
                        },
                        component: CourseOfferedEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                ]
            },
            //cursos-ofertados-profesor
            {
                path: 'cursos-ofertados-profesor',
                meta: {
                    label: 'Cursos',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'CoursesOfferedTeacherList',
                        meta: {
                            label: 'Lista de cursos asignados',
                        },
                        component: CoursesOfferedTeacherList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_TEACHER]);
                        },
                    },
                ]
            },
            //calificaciones
            {
                path: '/calificaciones',
                meta: {
                    label: 'Calificaciones',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'importar/:id',
                        name: 'GradesImport',
                        meta: {
                            label: 'Importar calificaciones',
                        },
                        component: GradesImport,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_TEACHER]);
                        },
                    },
                ]
            },
            //horarios-profesor
            {
                path: 'horarios-profesor',
                meta: {
                    label: 'Horarios asignados',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'TeacherScheduleList',
                        meta: {
                            label: 'Lista de horarios asignados',
                        },
                        component: TeacherScheduleList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_TEACHER]);
                        },
                    },
                ]
            },
            //programaciones
            {
                path: 'programaciones',
                meta: {
                    label: 'Programaciones',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'RegistrationsStudentList',
                        meta: {
                            label: 'Lista de programaciones',
                        },
                        component: RegistrationsStudentList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_STUDENT]);
                        },
                    },
                ]
            },
            //pensiones
            {
                path: 'pensiones',
                meta: {
                    label: 'Pensiones',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'RegistrationsWithTuitionsList',
                        meta: {
                            label: 'Lista de pensiones',
                        },
                        component: RegistrationsWithTuitionsList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_STUDENT]);
                        },
                    },
                ]
            },
            //tipo de pensiones
            {
                path: 'tipos-de-pensiones',
                meta: {
                    label: 'Tipo de pensiones',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'SyllabusTuitionsList',
                        meta: {
                            label: 'Lista de tipo de pensiones',
                        },
                        component: SyllabusTuitionsList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'crear',
                        name: 'SyllabusTuitionAdd',
                        meta: {
                            label: 'Añadir tipo de pensiones'
                        },
                        component: SyllabusTuitionAdd,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                    {
                        path: 'editar/:id',
                        name: 'SyllabusTuitionEdit',
                        meta: {
                            label: 'Editar tipo de pensiones'
                        },
                        component: SyllabusTuitionEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR]);
                        },
                    },
                ]
            },
            //libreta
            {
                path: 'libreta',
                meta: {
                    label: 'Libreta',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'ReportCard',
                        meta: {
                            label: 'Libreta',
                        },
                        component: ReportCard,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_STUDENT]);
                        },
                    },
                ]
            },
            //kardex
            {
                path: 'kardex',
                meta: {
                    label: 'Kardex',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'Kardex',
                        meta: {
                            label: 'Kardex',
                        },
                        component: Kardex,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_STUDENT]);
                        },
                    },
                ]
            },
            // ventas
            {
                path: 'ventas',
                meta: {
                    label: 'Ventas',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'SalesList',
                        meta: {
                            label: 'Lista de ventas',
                        },
                        component: SalesList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'crear/:id',
                        name: 'SaleEdit',
                        meta: {
                            label: 'Crear Ventas',
                        },
                        component: SaleEdit,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'ver/:id',
                        name: 'SaleView',
                        meta: {
                            label: 'Ver Venta',
                        },
                        component: SaleView,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                ]
            },
            //reportes
            {
                path: 'reportes',
                meta: {
                    label: 'Reportes',
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'horarios',
                        name: 'Horarios',
                        meta: {
                            label: 'Horarios',
                        },
                        component: ScheduleList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'deuda-pensiones',
                        name: 'deuda-pensiones',
                        meta: {
                            label: 'Dueda de pensiones',
                        },
                        component: RegistrationsDebtList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'recaudaciones',
                        name: 'recaudaciones',
                        meta: {
                            label: 'Recaudaciones',
                        },
                        component: IncomeList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'calificaciones-por-periodo',
                        name: 'calificaciones-por-periodo',
                        meta: {
                            label: 'Estadisticas por periodo',
                        },
                        component: StatisticsByPeriodsList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'estadistica-generales-por-periodo',
                        name: 'estadistica-generales-por-periodo',
                        meta: {
                            label: 'Estadisticas generales por periodo',
                        },
                        component: StatisticsGeneralByPeriodsList,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY]);
                        },
                    },
                    {
                        path: 'estudiantes-programados',
                        name: 'estudiantes-programados',
                        meta: {
                            label: 'Estudiantes Programados',
                        },
                        component: RegistrationStudents,
                        beforeEnter: (to, from, next) => {
                            guard(to, from, next, [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY, roles.ROLE_SYSTEM]);
                        },
                    },


                ]
            },
            //error
            {
                path: 'error',
                meta: {
                    label: 'Páginas'
                },
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: '401',
                        meta: {
                            label: 'Sin autorización'
                        },
                        name: 'Page_401',
                        component: Page_401
                    },
                    {
                        path: '500',
                        meta: {
                            label: 'Error de servidor'
                        },
                        name: 'Page_500',
                        component: Page_500
                    },
                ]
            },
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

export default router;